import { Wysiwyg } from "@/styles/typography";
import React from "react";
import S from "./StandardEditor.styled";

export interface Props {
  wysiwyg: string;
}

const StandardEditor = (props: Props) => {
  return (
    <div className="main-inner">
      <S.TextWrapper>
        <Wysiwyg dangerouslySetInnerHTML={{ __html: props.wysiwyg }} />
      </S.TextWrapper>
    </div>
  );
};

export default StandardEditor;
